
import { Vue, Component, Prop, Emit } from "vue-property-decorator"
import api from "../honcierge-api"
import DeleteButtonWithConfirm from "@/components/DeleteButtonWithConfirm.vue"
import { AnalyticsGroup } from "types/analyticsGroup"
import { AxiosError } from "axios"

@Component({
  components: { DeleteButtonWithConfirm },
})
export default class EditAnalyticsGroup extends Vue {
  @Prop()
  private dialog!: boolean

  public id: AnalyticsGroup["data"]["id"] = -1 // 正なら新規作成, そうでないなら更新処理を行う
  public name = ""
  public keyName = ""
  public description = ""

  // rules for form
  private nameRules = [(name: string) => !!name || "名前は必須です"]
  private keyNameRules = [(keyName: string) => !!keyName || "Keyは必須です"]

  public updateAnalyticsGroup(): void {
    if (!this.validate()) {
      return
    }
    api
      .updateAnalyticsGroup({
        id: this.id,
        name: this.name,
        keyName: this.keyName,
        description: this.description,
      })
      .then(() => {
        this.emitAnalyticsGroup()
        this.$toasted.success("アナリティクスグループを更新しました")
      })
      .catch((e: AxiosError) => {
        if (e.response) {
          this.$toasted.error(e.response.data.messages)
        }
      })
  }

  public createAnalyticsGroup(): void {
    if (!this.validate()) {
      return
    }
    api
      .createAnalyticsGroup({
        name: this.name,
        keyName: this.keyName,
        description: this.description,
      })
      .then(() => {
        this.emitAnalyticsGroup()
        this.$toasted.success("アナリティクスグループを新規作成しました")
      })
      .catch((e: AxiosError) => {
        if (e.response) {
          this.$toasted.error(e.response.data.messages)
        }
      })
  }

  public deleteAnalyticsGroup(): void {
    api
      .deleteAnalyticsGroup(this.id)
      .then(() => {
        this.$toasted.success("アナリティクスグループを削除しました")
        this.emitAnalyticsGroup()
      })
      .catch((error: AxiosError) => {
        console.log(error.stack)
        this.$toasted.error("アナリティクスグループの削除に失敗しました")
      })
  }

  @Emit("emitAnalyticsGroup")
  private emitAnalyticsGroup() {
    this.close()
  }

  @Emit("close")
  private close() {
    this.clear()
  }

  private validate(): boolean {
    const form = this.$refs.form as InstanceType<typeof EditAnalyticsGroup>
    return form.validate()
  }

  private resetValidation(): void {
    const form = this.$refs.form as InstanceType<typeof EditAnalyticsGroup>
    return form.resetValidation()
  }

  private clear() {
    this.init()
    this.resetValidation()
  }

  private init() {
    this.id = -1
    this.name = ""
    this.keyName = ""
    this.description = ""
  }
}
